import { useState } from 'react';
import { Box, Flex, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import CustomDropzone from 'UiKit/drop-zone';
import { TextBold, TextSemiBold } from 'UiKit/typography';
import ButtonSolid from 'UiKit/button/buttonSolid';
import useGetScheduleTemplate from 'Domain/schedule/useGetScheduleTemplate';
import usePostImportSchedule from 'Domain/schedule/usePostImportSchedule';
import { ChevronRightIcon, CloseIcon, DownloadIcon } from 'Asset/icon';

import UploadedFile from 'View/schedule/component/uploaded-file';
import ProgressUploadFile from 'View/schedule/component/progress-upload-file';
import { useScheduleState } from 'View/schedule/state';

import styles from './styles.module.css';

const FormUpload = () => {
  const { t } = useTranslation('schedule');
  const { state, updateState, filterState } = useScheduleState();
  const [file, setFile] = useState(null);

  const { mutate: downloadTemplateSchedule } = useGetScheduleTemplate();
  const { mutate: importTemplateSchedule } = usePostImportSchedule({ setFile, filterState });

  const onDrop = (acceptedFiles) => setFile(acceptedFiles[0]);

  const onClose = () => updateState({ isOpenFormUpload: false, isUploadLoad: false });

  return (
    <Modal isOpen={state?.isOpenFormUpload} size={'xl'} isCentered onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxWidth={'656px'}>
        <ModalHeader>
          <Box className={styles['form-upload__header-container']}>
            <TextBold className={styles['form-upload__title']}>{t('uploadFileTitle')}</TextBold>
            <CloseIcon width="20px" height="20px" onClick={onClose} color="var(--color-primary70)" className={styles['form-upload__header-button-close']} />
          </Box>
        </ModalHeader>

        <ModalBody>
          <Condition statement={!state?.isUploadLoad} fallback={<ProgressUploadFile />}>
            <Condition statement={!file} fallback={<UploadedFile file={file} setFile={setFile} />}>
              <CustomDropzone
                onDrop={onDrop}
                descText={t('uploadFormat')}
                maxSize={1048576}
                textError={t('uploadSizeError')}
              />
            </Condition>
          </Condition>
        </ModalBody>

        <ModalFooter className={styles['form-upload__footer']}>
          <Condition statement={!state?.isUploadLoad}>
            <Flex justifyContent={'space-between'} width={'100%'}>
              <Button variant={'link'} className={styles['form__button--download']} onClick={downloadTemplateSchedule}>
                <DownloadIcon width="20px" height="20px" color="var(--color-info60)" /> {t('downloadTemplate')}
              </Button>

              <ButtonSolid className={styles['form__button--lanjutkan']} disabled={!file} onClick={() => importTemplateSchedule({ file })}>
                <TextSemiBold className={styles['form__button--lanjutkan-text']}>{t('continueButton')}</TextSemiBold>
                <ChevronRightIcon width="22px" height="22px" color="var(--color-semantic-white)" />
              </ButtonSolid>
            </Flex>
          </Condition>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FormUpload;
